(() => {
  const initialize = () => {
    document.querySelectorAll('[data-legal-guarantee]').forEach((root) => {
      const openButton = root.querySelector('[data-legal-guarantee-open]');
      const dialog = root.querySelector('[data-legal-guarantee-dialog]');

      if (!openButton || !dialog || typeof dialog.showModal !== 'function') {
        return;
      }

      let returnFocus = null;

      openButton.addEventListener('click', (event) => {
        event.preventDefault();
        returnFocus = document.activeElement;
        dialog.showModal();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          dialog.close();
        }
      });

      dialog.addEventListener('close', () => {
        if (returnFocus && returnFocus.isConnected) {
          returnFocus.focus();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();